import {
  Project,
  Identifiable,
  ProjectExpense,
  Attachment,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function saveProjectExpense(httpClient: HttpClient) {
  return (project: Identifiable<Project>, projectExpense: ProjectExpense) =>
    new Promise<Identifiable<ProjectExpense>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<ProjectExpense>>({
          endpoint: "/expenses",
          method: HttpMethods.POST,
          data: {
            ...projectExpense,
            attachments: [],
            project: `projects/${project.uuid}`,
            expenseType: `expenseTypes/${projectExpense.expenseType.uuid}`,
          },
        })
        .then(async (createdProjectExpense) => {
          return Promise.all(
            projectExpense.attachments.map((document) => {
              return httpClient.sendHttpRequest<Identifiable<Attachment>>({
                endpoint: `/expenses/${createdProjectExpense.uuid}/attachments`,
                method: HttpMethods.POST,
                data: {
                  projectUuid: project.uuid,
                  attachmentType: document.type.toUpperCase(),
                  attachedEntityUuid: document.uuid,
                },
              });
            }),
          ).then(() => ({
            ...createdProjectExpense,
            attachments: projectExpense.attachments,
          }));
        })
        .then((createdProjectExpense) =>
          resolve({
            ...createdProjectExpense,
            expenseType: projectExpense.expenseType,
          }),
        )
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { saveProjectExpense };
